module.exports = __webpack_public_path__ + "static/media/inforgraphics.dbf83599.svg";